module.exports = __webpack_public_path__ + "img/1518113796.906020fa.jpg";